import { Skeleton } from '@chakra-ui/react';
import { type FC } from 'react';

import {
  getRandomPopularity,
  popularityToImageSize,
} from '$/pages/DashboardPages/pages/Inspiration/utils/popularityUtils';

interface Props {
  id: number;
  onlyNormalSize?: boolean;
}

export const LoadingInspirationCard: FC<Props> = ({ id, onlyNormalSize }) => {
  const imageSize = popularityToImageSize(
    getRandomPopularity(id),
    id.toString(),
    onlyNormalSize,
  );

  return (
    <Skeleton
      layerStyle='SceneImage'
      w='100%'
      maxW='100%'
      h='100%'
      borderRadius='12px'
      _hover={{
        transform: 'scale(1.02)',
        transition: 'transform 300ms ease',
      }}
      {...imageSize}
    />
  );
};
